import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../../lib/cx";
import styles from "./StatusDot.module.css";

export type StatusTone = "ok" | "warn" | "error" | "muted";

export type StatusDotProps = {
  tone?: StatusTone;
  children: ReactNode;
} & HTMLAttributes<HTMLSpanElement>;

export const StatusDot = ({ tone = "ok", className, children, ...rest }: StatusDotProps) => (
  <span data-tone={tone} className={cx(styles.status, className)} {...rest}>
    <span className={styles.dot} aria-hidden="true" />
    <span>{children}</span>
  </span>
);
